// extracted by mini-css-extract-plugin
export default {"spinning":"SyncButton__spinning___c5E8g","spin":"SyncButton__spin___n3J8Z"};